<template>
  <r-checkbox :value="value" size="lg" :class="customClass" dense v-on="$listeners">
    <slot/>
  </r-checkbox>
</template>

<script>
import RCheckbox from '@/components/base/RCheckbox';

export default {
  name: 'DefaultCheckbox',
  components: { RCheckbox },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    customClass: String,
  },
};
</script>
